import { connect } from "react-redux";
import { ServiceDetailsOverlay as Component, ServiceDetailsOverlayProps } from "./ServiceDetailsOverlay.component";
import {
  submitServiceRequest,
  updatedEpcsStatus,
  updateServiceTypeOptions,
  updateVehicle,
  updatePpuFuelPrice,
  logChatIntakeResults,
  refreshReducersToInitial,
} from "../../action";
import { getIncidentReportFormComplete, getMakeModel, getTowReason, getNeedsTransportResponse, getReplacementRentalCarResponse, getCustomerType, getSchedulingEnabled, getReadyToSubmitRescue } from "../../selector";
import { getOmniStreamlinedFlag } from "../../features/FeatureFlags";
import { RootState } from "../../reducers";

const mapStateToProps = (state: RootState) => {
  const experience = state.partnerDetails.partnerDetails.experience;
  const passThruEnabled = experience?.passThruEnabled;
  const serviceSelectionEnabled = experience?.serviceSelectionEnabled;
  const customDestinationEnabled = experience?.customDestinationEnabled;
  const isPepPartner =
    passThruEnabled === false && serviceSelectionEnabled === false && customDestinationEnabled === false;

  return {
    commonBenefits: state.commonBenefits,
    destination: state.destination,
    epcsStatus: state.epcsStatus,
    incidentReportFormComplete: getIncidentReportFormComplete(state),
    isPepPartner,
    makeModel: getMakeModel(state),
    omniStreamlined: getOmniStreamlinedFlag(state),
    partnerDetails: state.partnerDetails.partnerDetails,
    serviceInfo: state.serviceInfo,
    serviceRequestPayload: state.serviceRequestPayload,
    submitRequest: state.submitRequest,
    towReasonId: getTowReason(state),
    replacementRentalCarFromRedux: getReplacementRentalCarResponse(state),
    needsTransportFromRedux: getNeedsTransportResponse(state),
    customerType: getCustomerType(state),
    schedulingEnabled: getSchedulingEnabled(state),
    readyToSubmitRescue : getReadyToSubmitRescue(state)
  } as Pick<
    ServiceDetailsOverlayProps,
    | "commonBenefits"
    | "destination"
    | "epcsStatus"
    | "incidentReportFormComplete"
    | "isPepPartner"
    | "makeModel"
    | "omniStreamlined"
    | "partnerDetails"
    | "serviceInfo"
    | "serviceRequestPayload"
    | "submitRequest"
    | "towReasonId"
    | "replacementRentalCarFromRedux"
    | "needsTransportFromRedux"
    | "customerType"
    | "schedulingEnabled"
    | "readyToSubmitRescue"
  >;
};

const mapDispatchToProps = {
  logChatIntakeResults,
  refreshReducersToInitial,
  submitServiceRequest,
  updatePpuFuelPrice,
  updateServiceTypeOptions,
  updateVehicle,
  updatedEpcsStatus,
} as Pick<
  ServiceDetailsOverlayProps,
  | "logChatIntakeResults"
  | "refreshReducersToInitial"
  | "submitServiceRequest"
  | "updatePpuFuelPrice"
  | "updateServiceTypeOptions"
  | "updateVehicle"
  | "updatedEpcsStatus"
>;

export const ServiceDetailsOverlay = connect(mapStateToProps, mapDispatchToProps)(Component);
